import { SleepReportScope } from 'mormaii-web-presentation/sleep-report'
import type { ViewFactory } from 'wdc-cube-solid'

import { SleepReportView } from './v-sleep-report'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(SleepReportScope, SleepReportView)
}

export { SleepReportView }
